import { useLang, tx } from "@/context/LanguageContext";
import { DESTINATIONS } from "@/data";

export const Destinations = () => {
  const { t, lang } = useLang();
  return (
    <section id="destinations" className="py-20 md:py-32 bg-sand-surface" data-testid="destinations-section">
      <div className="px-6 md:px-12 lg:px-20 mx-auto max-w-7xl">
        <div className="max-w-2xl mb-16">
          <p className="font-body text-xs tracking-[0.25em] uppercase text-teal font-bold mb-4">{t.destinations.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-jungle mb-5">{t.destinations.title}</h2>
          <p className="font-body text-jungle-light/80 leading-relaxed">{t.destinations.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {DESTINATIONS.map((d, i) => (
            <div
              key={d.id}
              data-testid={`destination-card-${d.id}`}
              className={`group relative overflow-hidden cursor-pointer ${i === 0 ? "col-span-2 lg:col-span-2 lg:row-span-2" : ""}`}
            >
              <img
                src={d.image}
                alt={tx(d.name, lang)}
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-700 ${i === 0 ? "h-72 lg:h-full" : "h-44 md:h-60"}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-jungle/90 via-jungle/20 to-transparent" />
              <div className="absolute bottom-0 left-0 p-5 md:p-7">
                <span className="font-body text-[10px] tracking-[0.2em] uppercase text-teal font-bold">{tx(d.tag, lang)}</span>
                <h3 className="font-heading text-xl md:text-3xl font-semibold text-sand leading-tight mt-1">{tx(d.name, lang)}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
